module.exports = __webpack_public_path__ + "img/playerEval.acab50e3.svg";